const apiUrl = process.env.REACT_APP_API_URL;

export const DeleteBbddEnviament = async (idResposta: string | number) => {
    try {
        const response = await fetch(`${apiUrl}:8061/bbdd/problemes/enviament/${idResposta}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!response.ok) {
            throw new Error(`Error en eliminar l'enviament: ${response.statusText}`);
        }
        return await response.json().catch(() => ({ success: true }));
    } catch (error) {
        console.error('Error al eliminar enviament:', error);
        throw error;
    }
};
